import styled from "styled-components";
import Flex from "../Flex";
import { colorMixin, typographyMixin } from "../../helpers";

export const Card = styled(Flex)`
    box-sizing: border-box;
    background: ${colorMixin("background-primary-base")};
    overflow: hidden;
    border-radius: 8px;
    border: 1px solid ${colorMixin("border-primary-200")};
    padding: 16px;
    width: fit-content;
`;

export const Title = styled.label`
    ${typographyMixin("label-x-small-regular")};
    color: ${colorMixin("text-primary-600")};
    text-transform: uppercase;
    letter-spacing: 0.08em;
`;
